import React, { useEffect, useState, useRef, useCallback } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { DialogDelete, DialogConfirm } from "../../../components/DialogService/DialogService";
import { FooterButtonCenter } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { FooterButtonSigleCustom } from "../../../components/FooterButton/FooterButton";

// PAGE
import P243List from "./P243List";

// SERVICE
import { pAssessmentScoreInfo, pAssessmentScoreUpdate } from "../../../service/200/P243Service";

export default function P243() {
    const history = useHistory();

    const toast = useRef(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dialog, setDialog] = useState({ dialog: false, action: "" });

    // SEARCH
    const [searchData, setSearchData] = useState({ contractNo: "", assessmentNo: 0, userId: dataUserSession() ? dataUserSession().userId : "" });

    // DATA
    const [dataTable, setDataTable] = useState([]);
    const [dataForm, setDataForm] = useState(null);
    const [errData, setErrData] = useState(null);
    const [count, setCount] = useState(0);

    // Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setSearchData({
                    ...searchData,
                    ...history.location.state.dataSrh,
                });
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        if (searchData.contractNo !== "") onGetpAssessmentScoreInfo();
    }, [searchData]);

    const addRowTotal = (index, TotalItemWeight, TotalItemPoint) => {
        const obj = {
            inputFlag: "N",
            inputFlagSum: "Y",
            itemDesc: "รวม",
            itemWeight: TotalItemWeight,
            itemPoint: TotalItemPoint,
            index: index,
        };

        return obj;
    };

    const onGetpAssessmentScoreInfo = () => {
        setLoading(true);
        pAssessmentScoreInfo(searchData).then(
            (res) => {
                setLoading(false);
                if (res != undefined) {
                    let temp = [];
                    let index = 0;
                    let TotalItemWeight = 0;
                    let TotalItemPoint = 0;

                    res.forEach((element) => {
                        if (TotalItemWeight !== null) {
                            TotalItemWeight += element.itemWeight;
                            TotalItemPoint += element.itemPoint;
                        }

                        if (element.itemGroupId !== "" && index > 0) {
                            temp.push(addRowTotal(index, TotalItemWeight, TotalItemPoint));
                            index++;
                            TotalItemWeight = 0;
                            TotalItemPoint = 0;
                        }

                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    temp.push(addRowTotal(index, TotalItemWeight, TotalItemPoint));
                    TotalItemWeight = 0;
                    setDataForm(temp[0]);
                    setDataTable(temp);
                    console.log(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const footerButtonSingle = () => {
        const con = () => {
            // alert("/200");
            // history.push("/200");
            setConfirmDialog(false);
        };
        return <FooterButtonSigleCustom btnLabel="ปิด" icon="pi pi-check" onClick={() => con()} />;
    };

    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };
    const submitForm = () => {
        // setLoading(true);
        let velifly = true;

        for (const iterator of dataTable) {
            if (iterator.inputFlag === "Y") {
                if (iterator.itemScore === null || iterator.itemScore === 0 || iterator.itemScore === "") {
                    velifly = false;
                }
            }
        }
        if (velifly) {
            let statusText = "";

            console.log(dataTable);

            for (let i = 0; i < dataTable.length; i++) {
                setTimeout(async () => {
                    if (dataTable[i].inputFlag === "Y") {
                        const req = {
                            assessmentNo: 1,
                            contractNo: searchData.contractNo,
                            itemScore: dataTable[i].itemScore,
                            updateRecordKey: dataTable[i].updateRecordKey,
                            userId: searchData.userId,
                        };

                        await pAssessmentScoreUpdate(req).then(
                            (res) => {
                                setLoading(false);
                                statusText = res[0].statusText;
                            },
                            function (err) {
                                setLoading(false);
                                setErrData(err);
                            }
                        );
                        if (i === dataTable.length - 2) {
                            handlerSettingDialogConfirm("", statusText);
                        }
                    }
                }, 1000);
            }
        } else {
            showMessages("error", "เกิดข้อผิดพลาด ", "กรุณาระบุคะแนนให้ครบ");
        }
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            setDeleteDialog(false);
        };

        return <FooterButtonCenter onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValViewForm = (_key) => {
        if (dataForm != undefined) return dataForm[_key];
    };

    const handlerGoPage = (obj) => {
        switch (obj.page) {
            case "242":
                history.push({ pathname: `/${obj.page}`, state: { dataSrh: { assessmentNo: searchData.assessmentNo, contractNo: searchData.contractNo } } });
                break;
            case "244":
                history.push({ pathname: `/${obj.page}`, state: { dataSrh: { assessmentNo: searchData.assessmentNo, contractNo: searchData.contractNo } } });
                break;

            default:
                break;
        }
    };
    const handlerRadioCheck = useCallback(
        (rowData, e) => {
            const objIndex = dataTable.findIndex((obj) => obj.index == rowData.index);
            dataTable[objIndex].itemScore = e;
            dataTable[objIndex].itemPoint = rowData.itemWeight * e;

            let totalItemPoint = 0;
            for (let i = 0; i < dataTable.length; i++) {
                if (dataTable[i].itemPoint !== undefined && dataTable[i].itemPoint !== null && dataTable[i].itemPoint !== "" && dataTable[i].inputFlag === "Y") {
                    totalItemPoint += parseInt(dataTable[i].itemPoint);
                }
                if (dataTable[i].inputFlagSum !== undefined && dataTable[i].inputFlagSum === "Y") {
                    dataTable[i].itemPoint = totalItemPoint;
                    totalItemPoint = 0;
                }
            }

            setCount(count + 1);
            setDataTable(dataTable);
        },
        [dataTable, count]
    );

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">คะแนนการประเมิน</h2>
                        <hr /> */}
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" value={searchData.contractNo} disabled={true} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="assessmentBeginDate">เริ่มประเมินจากวันที่</label>
                                <InputText id="assessmentBeginDate" value={setValViewForm("assessmentBeginDate")} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="assessmentEndDate">ถึงวันที่</label>
                                <InputText id="assessmentEndDate" value={setValViewForm("assessmentEndDate")} disabled={true} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractorName">ผู้รับจ้าง</label>
                                <InputText id="contractorName" type="text" placeholder="ระบุ ผู้รับจ้าง" value={setValViewForm("contractorName")} disabled={true} />
                            </div>
                        </div>
                        <br />

                        <P243List dataTable={dataTable} setChange={handlerRadioCheck} setActionDetail={handlerGoPage} />

                        <br />
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <Button className="p-button-success p-button p-mr-2 p-mb-2" icon="pi pi-save" label="บันทึก" style={{ width: 170 }} onClick={() => submitForm()} />
                                <Button className="p-button-secondary p-button p-mr-2 p-mb-2" icon="pi pi-arrow-left" label="กลับหน้าจอหลัก" style={{ width: 170, marginLeft: "5px" }} onClick={() => handlerGoPage({ page: "242" })} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
            <DialogDelete visible={deleteDialog.open} header="การยืนยัน" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="คุณต้องการลบข้อมูล ใช่หรือไม่ ?" />
        </>
    );
}
